import { Box, Button, Divider, Typography } from '@mui/material';
import React from 'react';
import { card, lineBorder, mainText, typeText } from './AliasCard.sx';
import { iconBox, secondaryText } from 'app/components/AccordionCustom/AccountSummary/AccountSummary.sx';
import WalletIcon from 'app/components/Icons/SafeIcon';
import useCurrencySymbol from 'app/utils/customHooks/useCurrencySymbol';
import { green, yellow } from 'app/components/ThemeProvider/colors';
import AccountsAddModal from 'app/pages/AccountsCardsPage/AccountAddModal';
import useAliasCard from 'app/pages/AccountsCardsPage/AliasCard/useAliasCard';

interface Props {
  headerText: string;
  type: string;
  accountsModal: boolean;
  setAccountsModal: (prop: boolean) => void;
}
const AliasCard = (props: Props) => {
  const { headerText, type, accountsModal, setAccountsModal } = props;

  return (
    <Box sx={card}>
      <>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
            <Typography sx={mainText}>{headerText}</Typography>
            <Typography sx={typeText}>{type}</Typography>
          </Box>
          <Button
            onClick={() => {
              setAccountsModal(true);
            }}
            color={'info'}
          >
            <Typography sx={{ color: 'white', fontWeight: '500' }}>Hesab əlavə et</Typography>
          </Button>
        </Box>
        <Box sx={lineBorder} />
        <Box sx={{ display: 'flex', gap: '24px', alignItems: 'center', width: '100%', pr: '28px', mt: '28px' }}>
          <Box
            sx={{
              ...iconBox,
              backgroundColor: 'rgba(36, 176, 126, 0.08)',
            }}
          >
            <WalletIcon color={'success'} />
          </Box>
          <Box sx={{ display: 'flex', gap: '100px', width: '100%' }}>
            <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', gap: '9px', alignItems: 'center' }}>
                <Typography sx={mainText}>My main acc title</Typography>
              </Box>
              <Typography sx={typeText}>AZ88NICB00600982750001A40060</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>2405 {useCurrencySymbol('AZN')}</Typography>
                <Typography sx={typeText}>Balans</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px', alignItems: 'center' }}>
                <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: green }}></Box>
                <Typography>Əsas</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: '24px', alignItems: 'center', width: '100%', pr: '28px', mt: '28px' }}>
          <Box
            sx={{
              ...iconBox,
              backgroundColor: 'rgba(36, 176, 126, 0.08)',
            }}
          >
            <WalletIcon color={'success'} />
          </Box>
          <Box sx={{ display: 'flex', gap: '100px', width: '100%' }}>
            <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
              <Box sx={{ display: 'flex', gap: '9px', alignItems: 'center' }}>
                <Typography sx={mainText}>My main acc title</Typography>
              </Box>
              <Typography sx={typeText}>AZ88NICB00600982750001A40060</Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
              <Box sx={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                <Typography sx={{ fontSize: '20px', fontWeight: 600 }}>2405 {useCurrencySymbol('AZN')}</Typography>
                <Typography sx={typeText}>Balans</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px', alignItems: 'center' }}>
                <Box sx={{ width: '12px', height: '12px', borderRadius: '50%', background: green }}></Box>
                <Typography>Əsas</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </>
    </Box>
  );
};

export default AliasCard;
